import { css } from "styled-components/macro";
import { rem } from "polished";

import { colors } from "./Styles.variables";

const borderStyle = `${rem("2px")} solid ${colors.gray800}`;
const innerOffsetX = rem("8px");

const borderBottom = css`
  &:first-child {
    padding-top: 0;
  }

  border-bottom: ${borderStyle};
`;

const borderTop = css`
  &:first-child {
    padding-top: ${rem("9px")};
  }

  &:not(:first-child) {
    border-top: ${borderStyle};
    padding-top: ${rem("24px")};
  }
`;

export const listingMobileStyles = css`
  padding-bottom: ${rem("14px")};

  &:not(.listing-has-changes) {
    ${({ border }) => (border === "bottom" ? borderBottom : borderTop)};

    &:not(:first-child) {
      padding-top: ${rem("24px")};
    }
  }

  &.listing-has-changes {
    padding-top: ${rem("7px")};

    &:first-child {
      padding-top: ${rem("8px")};
    }
  }

  .callout + & {
    border-top: none !important;
  }

  .listing-changes {
    margin-bottom: ${rem("22px")};
  }

  .listing-photo {
    margin-bottom: ${rem("16px")};

    .listing-photo-container {
      background-color: ${colors.gray200};
      height: 0;
      overflow: hidden;
      padding-top: 57.1428571%;
      position: relative;
    }
  }

  .listing-categories {
    font-size: ${rem("12px")};
    line-height: 1;
    margin-bottom: ${rem("5px")};
    padding-left: ${innerOffsetX};
    padding-right: ${innerOffsetX};
    text-transform: uppercase;

    .categories-loading,
    .category:not(:last-child) {
      color: ${colors.gray600};
    }
  }

  .listing-title {
    color: ${colors.yellow};
    font-size: ${rem("24px")};
    margin-bottom: ${rem("6px")};
    padding-left: ${innerOffsetX};
    padding-right: ${innerOffsetX};
  }

  .listing-location {
    font-size: ${rem("20px")};
    padding-left: ${innerOffsetX};
    padding-right: ${innerOffsetX};
    margin-bottom: ${rem("16px")};
  }

  .listing-meta {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding-left: ${innerOffsetX};
    padding-right: ${innerOffsetX};

    li:not([class*="listing-meta-break"]) {
      margin-bottom: ${rem("22px")};

      &:not(:first-child) {
        border-left: ${rem("1px")} solid ${colors.gray600};
        padding-left: ${rem("14px")};
      }

      &:not(:last-child) {
        padding-right: ${rem("14px")};
      }
    }

    li[class*="listing-meta-break"] {
      display: none;
      width: 100%;

      @media only screen and (max-width: ${rem("600px")}) {
        &.listing-meta-break-xs {
          display: block;

          & + li {
            border-left: 0 none;
            padding-left: 0;
          }
        }
      }
    }

    .label-block {
      color: ${colors.gray600};
      font-size: ${rem("12px")};
    }

    strong {
      font-size: ${rem("18px")};
      white-space: nowrap;
    }

    small {
      font-size: ${rem("13px")};
    }

    .value-listed {
      color: ${colors.gray600};
      font-size: ${rem("13px")};
      padding-top: ${rem("3px")};
    }

    @media (min-width: ${rem("480px")}) {
      strong {
        font-size: ${rem("19px")};
      }
    }
  }

  .listing-view {
    margin-bottom: ${rem("24px")};

    a,
    button {
      display: block;
      font-size: ${rem("17px")};
    }

    &.listing-view-multiple {
      a,
      button {
        &:not(:last-child) {
          margin-bottom: ${rem("16px")};
        }
      }
    }
  }

  .listing-actions {
    font-size: ${rem("14px")};
    justify-content: center;

    > * {
      margin: 0 ${innerOffsetX} ${rem("4px")};
    }
  }
`;
